import { DateTime } from "luxon";
import React from "react";
import { useSessionStore } from "../../../../Stores/SessionStore";
import GradientButton from "../../../Core/GradientButton";

export default function PackageDetails(props) {
	const store = useSessionStore();
	const radiusDetails = props.details?.RadiusDetails;

	return (
		<div className="portal-dashboard-card h-100">
			<div className="portal-dashboard-card-header">
				<h4>Current Package</h4>
			</div>
			<div className="portal-dashboard-card-body">
				{radiusDetails ? (
					<>
						{radiusDetails.ServiceId > 0 && !store.CustomerHasActiveService() && (
							<>
								<div className="portal-package-green">{radiusDetails.ServiceName}</div>
								<div className="portal-package-green">
									Expiry Date: {DateTime.fromISO(radiusDetails.ExpiryDate).toFormat("dd/MM/yyyy")}
								</div>
							</>
						)}
						{store.CustomerHasActiveService() && (
							<>
								<div className="portal-package-green">
									{`${props.details.Customer.SuccessfulRecharges[0].Package} ${
										props.details.Customer.SubscriptionToken ? "(Subscription)" : ""
									}`}
								</div>
								<div className="portal-package-green">
									Expiry Date: {DateTime.fromISO(radiusDetails.ExpiryDate).toFormat("dd/MM/yyyy")}
								</div>
								{props.details.Customer.SuccessfulRecharges[0] && (
									<h2 className="portal-package-price">R{props.details.Customer.SuccessfulRecharges[0].Amount}</h2>
								)}
								{props.details.Customer.SubscriptionToken && (
									<div className="mt-2">
										<GradientButton
											title="Update Credit Card"
											variant="greenYellow"
											onClick={() => {
												window.location.href = `${store.Config.payfastUrl}recurring/update/${props.details.Customer.SubscriptionToken}?return=${encodeURIComponent(store.Config.payfastSuccessUrl)}`;
											}}
										/>
									</div>
								)}
							</>
						)}
						{!store.CustomerHasActiveService() && radiusDetails.ServiceId === 0 && <div>None</div>}
					</>
				) : (
					<div>None</div>
				)}
			</div>
		</div>
	);
}
